

import { useAppSelector } from '@/configuration/setup/hooks';
import { selectCategorizedThreads } from '@/store/thread/threadSlice';

import { TUseThreadSortingParams } from '../types';

/**
 * Custom hook for spliting(ordering) threads into timesepans.
 * 
 * @param {TUseThreadSortingParams} params - Whether to handle only favorite threads or not
 * @returns threadsList - Sorted and categorized threads
 */

export const useThreadSorting = ({ favoriteOnly }: TUseThreadSortingParams) => {
  
  const threadsList = useAppSelector(selectCategorizedThreads(favoriteOnly));
  
  return { threadsList };
};